var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#BFC224",
    stroke: "#A5A817",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_5213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4204 40.5577L38.4202 40.5576L17.0598 26.0396V25.9375C17.0598 24.4905 18.2379 23.3125 19.6848 23.3125H60.3152C61.7622 23.3125 62.9402 24.4904 62.9402 25.9375V27.0432L41.6593 40.6044C40.6634 41.2388 39.3926 41.2189 38.4204 40.5577ZM43.035 42.7647L43.0352 42.7646L47.2611 40.0717L62.5782 55.3888C62.121 56.1661 61.277 56.6875 60.3152 56.6875H19.6848C18.723 56.6875 17.8791 56.1661 17.4219 55.3888L32.9051 39.9055L36.9807 42.6756C36.9807 42.6756 36.9808 42.6756 36.9808 42.6756C37.9137 43.3099 38.9932 43.628 40.074 43.628C41.1011 43.628 42.1299 43.341 43.035 42.7647ZM60.3152 20.75H19.6848C16.8199 20.75 14.4973 23.0724 14.4973 25.9375V54.0625C14.4973 56.9275 16.8199 59.25 19.6848 59.25H60.3152C63.1802 59.25 65.5027 56.9275 65.5027 54.0625V25.9375C65.5027 23.0724 63.1802 20.75 60.3152 20.75ZM62.9402 30.0806V52.1607L49.4538 38.6744L62.9402 30.0806ZM17.0598 52.1607V29.136L30.7677 38.4528L17.0598 52.1607Z",
    fill: "#A5A817",
    stroke: "#A5A817",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_5213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0c23fd4b37678124605e8a998af9c7fe.svg";
export { ForwardRef as ReactComponent };